/**
 * ============================================================
 * CUSTOM REVIEWS WIDGET — reviews-widget.js
 * ============================================================
 */
(function () {
  "use strict";

  const WIDGET_CONFIG = {
    REVIEWS_URL: CONFIG.REVIEWS_URL,
    SUBMIT_URL: CONFIG.SUBMIT_API,
    REVIEWS_PER_PAGE: 10,
    LOCALE_COLUMN_MAP: {
      en: "body",
      ar: "body_ar",
      "zh-hant": "body_zh_TW",
      "zh-tw": "body_zh_TW",
      "zh-hans": "body_zh_CN",
      "zh-cn": "body_zh_CN",
      zh: "body_zh_CN",
      cs: "body_cs",
      da: "body_da",
      nl: "body_nl",
      fi: "body_fi",
      fr: "body_fr",
      de: "body_de",
      el: "body_el",
      he: "body_he",
      hu: "body_hu",
      it: "body_it",
      ja: "body_ja",
      no: "body_no",
      pl: "body_pl",
      pt: "body_pt",
      ro: "body_ro",
      es: "body_es",
      sv: "body_sv",
    },
    UI_TEXT: {
      en: {
        title: "Customer Reviews", reviews: "Reviews", writeReview: "Write A Review", loadMore: "Load More", verified: "Verified", sortLabel: "Sort", sortRecent: "Most Recent", sortHigh: "Highest Rating", sortLow: "Lowest Rating", sortPhotos: "With Photos", customersRatings: "Customers Ratings", from: "From", reviewsLabel: "reviews", yourName: "Your Name *", yourNamePlaceholder: "Your Name", email: "Email (optional)", emailPlaceholder: "your@email.com", yourRating: "Your Rating", yourReview: "Your Review *", yourReviewPlaceholder: "Tell us about your experience...", addPhotos: "Add Photos (optional)", submit: "Submit Review", successMsg: "Thank you! Your review has been submitted.", errorName: "Please enter your name.", errorRating: "Please select a rating.", errorReview: "Please write your review.", pendingBadge: "Pending Approval", to: "to", noReviews: "No reviews yet. Be the first!"
      },
      ar: {
        title: "آراء العملاء", reviews: "المراجعات", writeReview: "اكتب مراجعة", loadMore: "تحميل المزيد", verified: "موثق", sortLabel: "ترتيب", sortRecent: "الأحدث", sortHigh: "أعلى تقييم", sortLow: "أدنى تقييم", sortPhotos: "مع صور", customersRatings: "تقييمات العملاء", from: "من", reviewsLabel: "مراجعة", yourName: "* اسمك", yourNamePlaceholder: "اسمك", email: "البريد الإلكتروني (اختياري)", emailPlaceholder: "your@email.com", yourRating: "تقييمك", yourReview: "* مراجعتك", yourReviewPlaceholder: "أخبرنا عن تجربتك...", addPhotos: "إضافة صور (اختياري)", submit: "إرسال المراجعة", successMsg: "شكراً! تم إرسال مراجعتك.", errorName: "يرجى إدخال اسمك.", errorRating: "يرجى اختيار تقييم.", errorReview: "يرجى كتابة مراجعتك.", pendingBadge: "قيد الموافقة", to: "إلى", noReviews: "لا توجد مراجعات بعد. كن الأول!"
      },
      "zh-hant": {
        title: "顧客評價", reviews: "評價", writeReview: "撰寫評價", loadMore: "載入更多", verified: "已驗證", sortLabel: "排序", sortRecent: "最新", sortHigh: "最高評分", sortLow: "最低評分", sortPhotos: "含照片", customersRatings: "顧客評分", from: "共", reviewsLabel: "則評價", yourName: "您的姓名 *", yourNamePlaceholder: "您的姓名", email: "電子郵件（選填）", emailPlaceholder: "your@email.com", yourRating: "您的評分", yourReview: "您的評價 *", yourReviewPlaceholder: "請分享您的使用體驗...", addPhotos: "新增照片（選填）", submit: "提交評價", successMsg: "感謝您！您的評價已提交。", errorName: "請輸入您的姓名。", errorRating: "請選擇評分。", errorReview: "請撰寫您的評價。", pendingBadge: "待審核", to: "至", noReviews: "尚無評價，成為第一位！"
      },
      "zh-tw": {
        title: "顧客評價", reviews: "評價", writeReview: "撰寫評價", loadMore: "載入更多", verified: "已驗證", sortLabel: "排序", sortRecent: "最新", sortHigh: "最高評分", sortLow: "最低評分", sortPhotos: "含照片", customersRatings: "顧客評分", from: "共", reviewsLabel: "則評價", yourName: "您的姓名 *", yourNamePlaceholder: "您的姓名", email: "電子郵件（選填）", emailPlaceholder: "your@email.com", yourRating: "您的評分", yourReview: "您的評價 *", yourReviewPlaceholder: "請分享您的使用體驗...", addPhotos: "新增照片（選填）", submit: "提交評價", successMsg: "感謝您！您的評價已提交。", errorName: "請輸入您的姓名。", errorRating: "請選擇評分。", errorReview: "請撰寫您的評價。", pendingBadge: "待審核", to: "至", noReviews: "尚無評價，成為第一位！"
      },
      "zh-hans": {
        title: "客户评价", reviews: "评价", writeReview: "写评价", loadMore: "加载更多", verified: "已验证", sortLabel: "排序", sortRecent: "最新", sortHigh: "最高评分", sortLow: "最低评分", sortPhotos: "带图", customersRatings: "客户评分", from: "共", reviewsLabel: "条评价", yourName: "您的姓名 *", yourNamePlaceholder: "您的姓名", email: "电子邮件（选填）", emailPlaceholder: "your@email.com", yourRating: "您的评分", yourReview: "您的评价 *", yourReviewPlaceholder: "请分享您的使用体验...", addPhotos: "添加照片（选填）", submit: "提交评价", successMsg: "谢谢！您的评价已提交。", errorName: "请输入您的姓名。", errorRating: "请选择评分。", errorReview: "请撰写您的评价。", pendingBadge: "待审核", to: "至", noReviews: "暂无评价，快来抢沙发！"
      },
      "zh-cn": {
        title: "客户评价", reviews: "评价", writeReview: "写评价", loadMore: "加载更多", verified: "已验证", sortLabel: "排序", sortRecent: "最新", sortHigh: "最高评分", sortLow: "最低评分", sortPhotos: "带图", customersRatings: "客户评分", from: "共", reviewsLabel: "条评价", yourName: "您的姓名 *", yourNamePlaceholder: "您的姓名", email: "电子邮件（选填）", emailPlaceholder: "your@email.com", yourRating: "您的评分", yourReview: "您的评价 *", yourReviewPlaceholder: "请分享您的使用体验...", addPhotos: "添加照片（选填）", submit: "提交评价", successMsg: "谢谢！您的评价已提交。", errorName: "请输入您的姓名。", errorRating: "请选择评分。", errorReview: "请撰写您的评价。", pendingBadge: "待审核", to: "至", noReviews: "暂无评价，快来抢沙发！"
      },
      zh: {
        title: "客户评价", reviews: "评价", writeReview: "写评价", loadMore: "加载更多", verified: "已验证", sortLabel: "排序", sortRecent: "最新", sortHigh: "最高评分", sortLow: "最低评分", sortPhotos: "带图", customersRatings: "客户评分", from: "共", reviewsLabel: "条评价", yourName: "您的姓名 *", yourNamePlaceholder: "您的姓名", email: "电子邮件（选填）", emailPlaceholder: "your@email.com", yourRating: "您的评分", yourReview: "您的评价 *", yourReviewPlaceholder: "请分享您的使用体验...", addPhotos: "添加照片（选填）", submit: "提交评价", successMsg: "谢谢！您的评价已提交。", errorName: "请输入您的姓名。", errorRating: "请选择评分。", errorReview: "请撰写您的评价。", pendingBadge: "待审核", to: "至", noReviews: "暂无评价，快来抢沙发！"
      },
      cs: {
        title: "Hodnocení Zákazníků", reviews: "Hodnocení", writeReview: "Napsat Hodnocení", loadMore: "Načíst Další", verified: "Ověřeno", sortLabel: "Seřadit", sortRecent: "Nejnovější", sortHigh: "Nejvyšší Hodnocení", sortLow: "Nejnižší Hodnocení", sortPhotos: "S Fotkami", customersRatings: "Hodnocení Zákazníků", from: "Z", reviewsLabel: "hodnocení", yourName: "Vaše Jméno *", yourNamePlaceholder: "Vaše Jméno", email: "E-mail (volitelné)", emailPlaceholder: "vas@email.cz", yourRating: "Vaše Hodnocení", yourReview: "Vaše Recenze *", yourReviewPlaceholder: "Podělte se o své zkušenosti...", addPhotos: "Přidat Fotky (volitelné)", submit: "Odeslat Hodnocení", successMsg: "Děkujeme! Vaše hodnocení bylo odesláno.", errorName: "Zadejte prosím své jméno.", errorRating: "Vyberte prosím hodnocení.", errorReview: "Napište prosím svou recenzi.", pendingBadge: "Čeká Na Schválení", to: "do", noReviews: "Zatím žádná hodnocení. Buďte první!"
      },
      da: {
        title: "Kundeanmeldelser", reviews: "Anmeldelser", writeReview: "Skriv en Anmeldelse", loadMore: "Indlæs Flere", verified: "Verificeret", sortLabel: "Sortér", sortRecent: "Seneste", sortHigh: "Højeste Vurdering", sortLow: "Laveste Vurdering", sortPhotos: "Med Billeder", customersRatings: "Kundevurderinger", from: "Fra", reviewsLabel: "anmeldelser", yourName: "Dit Navn *", yourNamePlaceholder: "Dit Navn", email: "E-mail (valgfrit)", emailPlaceholder: "din@email.dk", yourRating: "Din Vurdering", yourReview: "Din Anmeldelse *", yourReviewPlaceholder: "Fortæl os om din oplevelse...", addPhotos: "Tilføj Billeder (valgfrit)", submit: "Send Anmeldelse", successMsg: "Tak! Din anmeldelse er blevet sendt.", errorName: "Indtast venligst dit navn.", errorRating: "Vælg venligst en vurdering.", errorReview: "Skriv venligst din anmeldelse.", pendingBadge: "Afventer Godkendelse", to: "til", noReviews: "Ingen anmeldelser endnu. Vær den første!"
      },
      nl: {
        title: "Klantbeoordelingen", reviews: "Beoordelingen", writeReview: "Schrijf een Beoordeling", loadMore: "Meer laden", verified: "Geverifieerd", sortLabel: "Sorteren", sortRecent: "Meest Recent", sortHigh: "Hoogste Beoordeling", sortLow: "Laagste Beoordeling", sortPhotos: "Met Foto's", customersRatings: "Klantbeoordelingen", from: "Van", reviewsLabel: "beoordelingen", yourName: "Uw Naam *", yourNamePlaceholder: "Uw Naam", email: "E-mail (optioneel)", emailPlaceholder: "uw@email.com", yourRating: "Uw Beoordeling", yourReview: "Uw Recensie *", yourReviewPlaceholder: "Vertel ons over uw ervaring...", addPhotos: "Foto's toevoegen (optioneel)", submit: "Beoordeling indienen", successMsg: "Bedankt! Uw beoordeling is ingediend.", errorName: "Voer uw naam in.", errorRating: "Selecteer een beoordeling.", errorReview: "Schrijf uw beoordeling.", pendingBadge: "In afwachting van goedkeuring", to: "tot", noReviews: "Nog geen beoordelingen. Wees de eerste!"
      },
      fi: {
        title: "Asiakasarvostelut", reviews: "Arvostelut", writeReview: "Kirjoita Arvostelu", loadMore: "Lataa Lisää", verified: "Vahvistettu", sortLabel: "Lajittele", sortRecent: "Uusimmat", sortHigh: "Korkein Arvio", sortLow: "Alin Arvio", sortPhotos: "Kuvalliset", customersRatings: "Asiakkaiden Arviot", from: "Yhteensä", reviewsLabel: "arvostelua", yourName: "Nimesi *", yourNamePlaceholder: "Nimesi", email: "Sähköposti (valinnainen)", emailPlaceholder: "sinun@sahkoposti.fi", yourRating: "Arviosi", yourReview: "Arvostelusi *", yourReviewPlaceholder: "Kerro kokemuksestasi...", addPhotos: "Lisää Kuvat (valinnainen)", submit: "Lähetä Arvostelu", successMsg: "Kiitos! Arvostelusi on lähetetty.", errorName: "Kirjoita nimesi.", errorRating: "Valitse arvio.", errorReview: "Kirjoita arvostelu.", pendingBadge: "Odottaa Hyväksyntää", to: "-", noReviews: "Ei vielä arvosteluja. Ole ensimmäinen!"
      },
      fr: {
        title: "Avis Clients", reviews: "Avis", writeReview: "Écrire un Avis", loadMore: "Charger Plus", verified: "Vérifié", sortLabel: "Trier", sortRecent: "Plus Récents", sortHigh: "Meilleure Note", sortLow: "Note la Plus Basse", sortPhotos: "Avec Photos", customersRatings: "Notes des Clients", from: "Sur", reviewsLabel: "avis", yourName: "Votre Nom *", yourNamePlaceholder: "Votre Nom", email: "Email (optionnel)", emailPlaceholder: "votre@email.com", yourRating: "Votre Note", yourReview: "Votre Avis *", yourReviewPlaceholder: "Partagez votre expérience...", addPhotos: "Ajouter des Photos (optionnel)", submit: "Soumettre l'Avis", successMsg: "Merci ! Votre avis a été soumis.", errorName: "Veuillez entrer votre nom.", errorRating: "Veuillez sélectionner une note.", errorReview: "Veuillez écrire votre avis.", pendingBadge: "En attente d'approbation", to: "à", noReviews: "Pas encore d'avis. Soyez le premier !"
      },
      de: {
        title: "Kundenbewertungen", reviews: "Bewertungen", writeReview: "Bewertung schreiben", loadMore: "Mehr laden", verified: "Verifiziert", sortLabel: "Sortieren", sortRecent: "Neueste", sortHigh: "Beste Bewertung", sortLow: "Schlechteste Bewertung", sortPhotos: "Mit Fotos", customersRatings: "Kundenbewertungen", from: "Von", reviewsLabel: "Bewertungen", yourName: "Ihr Name *", yourNamePlaceholder: "Ihr Name", email: "E-mail (optional)", emailPlaceholder: "ihre@email.com", yourRating: "Ihre Bewertung", yourReview: "Ihre Rezension *", yourReviewPlaceholder: "Teilen Sie Ihre Erfahrung...", addPhotos: "Fotos hinzufügen (optional)", submit: "Bewertung einreichen", successMsg: "Danke! Ihre Bewertung wurde eingereicht.", errorName: "Bitte geben Sie Ihren Namen ein.", errorRating: "Bitte wählen Sie eine Bewertung.", errorReview: "Bitte schreiben Sie Ihre Bewertung.", pendingBadge: "Ausstehende Genehmigung", to: "bis", noReviews: "Noch keine Bewertungen. Seien Sie der Erste!"
      },
      el: {
        title: "Κριτικές Πελατών", reviews: "Κριτικές", writeReview: "Γράψτε Κριτική", loadMore: "Φόρτωση Περισσότερων", verified: "Επαληθευμένο", sortLabel: "Ταξινόμηση", sortRecent: "Πιο Πρόσφατα", sortHigh: "Υψηλότερη Βαθμολογία", sortLow: "Χαμηλότερη Βαθμολογία", sortPhotos: "Με Φωτογραφίες", customersRatings: "Βαθμολογίες Πελατών", from: "Από", reviewsLabel: "κριτικές", yourName: "Το Όνομά σας *", yourNamePlaceholder: "Το Όνομά σας", email: "Email (προαιρετικό)", emailPlaceholder: "sas@email.gr", yourRating: "Η Βαθμολογία σας", yourReview: "Η Κριτική σας *", yourReviewPlaceholder: "Πείτε μας για την εμπειρία σας...", addPhotos: "Προσθήκη Φωτογραφιών (προαιρετικό)", submit: "Υποβολή Κριτικής", successMsg: "Ευχαριστούμε! Η κριτική σας υποβλήθηκε.", errorName: "Παρακαλώ εισάγετε το όνομά σας.", errorRating: "Παρακαλώ επιλέξτε βαθμολογία.", errorReview: "Παρακαλώ γράψτε την κριτική σας.", pendingBadge: "Εκκρεμεί Έγκριση", to: "έως", noReviews: "Δεν υπάρχουν κριτικές ακόμα. Γίνετε ο πρώτος!"
      },
      he: {
        title: "חוות דעת לקוחות", reviews: "חוות דעת", writeReview: "כתוב חוות דעת", loadMore: "טען עוד", verified: "מאומת", sortLabel: "מיון", sortRecent: "הכי חדש", sortHigh: "דירוג הכי גבוה", sortLow: "דירוג הכי נמוך", sortPhotos: "עם תמונות", customersRatings: "דירוגי לקוחות", from: "מתוך", reviewsLabel: "חוות דעת", yourName: "השם שלך *", yourNamePlaceholder: "השם שלך", email: "אימייל (אופציונלי)", emailPlaceholder: "שלך@email.co.il", yourRating: "הדירוג שלך", yourReview: "חוות הדעת שלך *", yourReviewPlaceholder: "ספר לנו על החוויה שלך...", addPhotos: "הוסף תמונות (אופציונלי)", submit: "שלח חוות דעת", successMsg: "תודה! חוות הדעת שלך נשלחה.", errorName: "אנא הכנס את שמך.", errorRating: "אנא בחר דירוג.", errorReview: "אנא כתוב את חוות הדעת שלך.", pendingBadge: "ממתין לאישור", to: "עד", noReviews: "אין עדיין חוות דעת. תהיה הראשון!"
      },
      hu: {
        title: "Vásárlói Értékelések", reviews: "Értékelések", writeReview: "Értékelés Írása", loadMore: "Több Betöltése", verified: "Ellenőrzött", sortLabel: "Rendezés", sortRecent: "Legújabb", sortHigh: "Legmagasabb Értékelés", sortLow: "Legalacsonyabb Értékelés", sortPhotos: "Fényképes", customersRatings: "Vásárlói Értékelések", from: "Ebből:", reviewsLabel: "értékelés", yourName: "Az Ön Neve *", yourNamePlaceholder: "Az Ön Neve", email: "E-mail (opcionális)", emailPlaceholder: "az-on@email-cime.hu", yourRating: "Az Ön Értékelése", yourReview: "Az Ön Véleménye *", yourReviewPlaceholder: "Mondja el nekünk a tapasztalatait...", addPhotos: "Fényképek Hozzáadása (opcionális)", submit: "Értékelés Beküldése", successMsg: "Köszönjük! Az értékelését beküldtük.", errorName: "Kérjük, adja meg a nevét.", errorRating: "Kérjük, válasszon értékelést.", errorReview: "Kérjük, írja meg a véleményét.", pendingBadge: "Jóváhagyásra Vár", to: "-", noReviews: "Még nincsenek értékelések. Legyen Ön az első!"
      },
      it: {
        title: "Recensioni dei Clienti", reviews: "Recensioni", writeReview: "Scrivi una Recensione", loadMore: "Carica Altro", verified: "Verificato", sortLabel: "Ordina", sortRecent: "Più Recenti", sortHigh: "Voto Più Alto", sortLow: "Voto Più Basso", sortPhotos: "Con Foto", customersRatings: "Valutazioni Clienti", from: "Su", reviewsLabel: "recensioni", yourName: "Il Tuo Nome *", yourNamePlaceholder: "Il Tuo Nome", email: "Email (opzionale)", emailPlaceholder: "tua@email.com", yourRating: "La Tua Valutazione", yourReview: "La Tua Recensione *", yourReviewPlaceholder: "Raccontaci la tua esperienza...", addPhotos: "Aggiungi Foto (opzionale)", submit: "Invia Recensione", successMsg: "Grazie! La tua recensione è stata inviata.", errorName: "Per favore inserisci il tuo nome.", errorRating: "Per favore seleziona una valutazione.", errorReview: "Per favore scrivi la tua recensione.", pendingBadge: "In attesa di approvazione", to: "a", noReviews: "Ancora nessuna recensione. Sii il primo!"
      },
      ja: {
        title: "お客様のレビュー", reviews: "レビュー", writeReview: "レビューを書く", loadMore: "もっと見る", verified: "確認済み", sortLabel: "並び替え", sortRecent: "最新順", sortHigh: "評価高い順", sortLow: "評価低い順", sortPhotos: "写真あり", customersRatings: "顧客評価", from: "件", reviewsLabel: "レビュー", yourName: "お名前 *", yourNamePlaceholder: "お名前", email: "メール（任意）", emailPlaceholder: "your@email.com", yourRating: "評価", yourReview: "レビュー *", yourReviewPlaceholder: "ご体験をお聞かせください...", addPhotos: "写真を追加（任意）", submit: "レビューを送信", successMsg: "ありがとうございます！レビューが送信されました。", errorName: "お名前を入力してください。", errorRating: "評価を選択してください。", errorReview: "レビューを書いてください。", pendingBadge: "承認待ち", to: "〜", noReviews: "まだレビューがありません。最初の一人になりましょう！"
      },
      no: {
        title: "Kundeanmeldelser", reviews: "Anmeldelser", writeReview: "Skriv en Anmeldelse", loadMore: "Last Inn Mer", verified: "Verifisert", sortLabel: "Sorter", sortRecent: "Nyeste", sortHigh: "Høyeste Vurdering", sortLow: "Laveste Vurdering", sortPhotos: "Med Bilder", customersRatings: "Kundevurderinger", from: "Av", reviewsLabel: "anmeldelser", yourName: "Ditt Navn *", yourNamePlaceholder: "Ditt Navn", email: "E-post (valgfritt)", emailPlaceholder: "din@epost.no", yourRating: "Din Vurdering", yourReview: "Din Anmeldelse *", yourReviewPlaceholder: "Fortell oss om din opplevelse...", addPhotos: "Legg til Bilder (valgfritt)", submit: "Send Anmeldelse", successMsg: "Takk! Din anmeldelse er sendt.", errorName: "Vennligst skriv inn navnet ditt.", errorRating: "Vennligst velg en vurdering.", errorReview: "Vennligst skriv din anmeldelse.", pendingBadge: "Avventer Godkjenning", to: "til", noReviews: "Ingen anmeldelser ennå. Bli den første!"
      },
      pl: {
        title: "Opinie Klientów", reviews: "Opinie", writeReview: "Napisz Opinię", loadMore: "Wczytaj Więcej", verified: "Zweryfikowany", sortLabel: "Sortuj", sortRecent: "Najnowsze", sortHigh: "Najwyższa Ocena", sortLow: "Najniższa Ocena", sortPhotos: "Ze Zdjęciami", customersRatings: "Oceny Klientów", from: "Z", reviewsLabel: "opinii", yourName: "Twoje Imię *", yourNamePlaceholder: "Twoje Imię", email: "E-mail (opcjonalnie)", emailPlaceholder: "twoj@email.pl", yourRating: "Twoja Ocena", yourReview: "Twoja Opinia *", yourReviewPlaceholder: "Opowiedz nam o swoich wrażeniach...", addPhotos: "Dodaj Zdjęcia (opcjonalnie)", submit: "Wyślij Opinię", successMsg: "Dziękujemy! Twoja opinia została wysłana.", errorName: "Proszę podać swoje imię.", errorRating: "Proszę wybrać ocenę.", errorReview: "Proszę napisać opinię.", pendingBadge: "Czeka na Akceptację", to: "do", noReviews: "Nie ma jeszcze opinii. Bądź pierwszy!"
      },
      pt: {
        title: "Avaliações dos Clientes", reviews: "Avaliações", writeReview: "Escrever uma Avaliação", loadMore: "Carregar Mais", verified: "Verificado", sortLabel: "Ordenar", sortRecent: "Mais Recentes", sortHigh: "Melhor Avaliação", sortLow: "Pior Avaliação", sortPhotos: "Com Fotos", customersRatings: "Avaliações dos Clientes", from: "De", reviewsLabel: "avaliações", yourName: "Seu Nome *", yourNamePlaceholder: "Seu Nome", email: "Email (opcional)", emailPlaceholder: "seu@email.com", yourRating: "Sua Avaliação", yourReview: "Sua Opinião *", yourReviewPlaceholder: "Conte-nos sobre sua experiência...", addPhotos: "Adicionar Fotos (opcional)", submit: "Enviar Avaliação", successMsg: "Obrigado! Sua avaliação foi enviada.", errorName: "Por favor insira seu nome.", errorRating: "Por favor selecione uma avaliação.", errorReview: "Por favor escreva sua avaliação.", pendingBadge: "Aguardando aprovação", to: "a", noReviews: "Ainda sem avaliações. Seja o primeiro!"
      },
      ro: {
        title: "Recenzii Clienți", reviews: "Recenzii", writeReview: "Scrie o Recenzie", loadMore: "Încarcă Mai Multe", verified: "Verificat", sortLabel: "Sortează", sortRecent: "Cele Mai Recente", sortHigh: "Cea Mai Mare Notă", sortLow: "Cea Mai Mică Notă", sortPhotos: "Cu Poze", customersRatings: "Evaluările Clienților", from: "Din", reviewsLabel: "recenzii", yourName: "Numele Tău *", yourNamePlaceholder: "Numele Tău", email: "Email (opțional)", emailPlaceholder: "adresa@email.com", yourRating: "Nota Ta", yourReview: "Recenzia Ta *", yourReviewPlaceholder: "Spune-ne despre experiența ta...", addPhotos: "Adaugă Poze (opțional)", submit: "Trimite Recenzia", successMsg: "Mulțumim! Recenzia ta a fost trimisă.", errorName: "Te rugăm să introduci numele.", errorRating: "Te rugăm să selectezi o notă.", errorReview: "Te rugăm să scrii recenzia.", pendingBadge: "În Așteptarea Aprobării", to: "la", noReviews: "Nicio recenzie încă. Fii primul!"
      },
      es: {
        title: "Opiniones de Clientes", reviews: "Opiniones", writeReview: "Escribir una Opinión", loadMore: "Cargar Más", verified: "Verificado", sortLabel: "Ordenar", sortRecent: "Más Recentes", sortHigh: "Mayor Puntuación", sortLow: "Menor Puntuación", sortPhotos: "Con Fotos", customersRatings: "Valoraciones de Clientes", from: "De", reviewsLabel: "opiniones", yourName: "Tu Nombre *", yourNamePlaceholder: "Tu Nombre", email: "Email (opcional)", emailPlaceholder: "tu@email.com", yourRating: "Tu Valoración", yourReview: "Tu Opinión *", yourReviewPlaceholder: "Cuéntanos tu experiencia...", addPhotos: "Añadir Fotos (opcional)", submit: "Enviar Opinión", successMsg: "¡Gracias! Tu opinión ha sido enviada.", errorName: "Por favor ingresa tu nombre.", errorRating: "Por favor selecciona una valoración.", errorReview: "Por favor escribe tu opinión.", pendingBadge: "Pendiente de aprobación", to: "a", noReviews: "Aún no hay opiniones. ¡Sé el primero!"
      },
      sv: {
        title: "Kundrecensioner", reviews: "Recensioner", writeReview: "Skriv en Recension", loadMore: "Ladda Mer", verified: "Verifierad", sortLabel: "Sortera", sortRecent: "Senaste", sortHigh: "Högsta Betyg", sortLow: "Lägsta Betyg", sortPhotos: "Med Bilder", customersRatings: "Kundbetyg", from: "Av", reviewsLabel: "recensioner", yourName: "Ditt Namn *", yourNamePlaceholder: "Ditt Namn", email: "E-post (valfritt)", emailPlaceholder: "din@epost.se", yourRating: "Ditt Betyg", yourReview: "Din Recension *", yourReviewPlaceholder: "Berätta om din upplevelse...", addPhotos: "Lägg till Bilder (valfritt)", submit: "Skicka Recension", successMsg: "Tack! Din recension har skickats.", errorName: "Vänligen ange ditt namn.", errorRating: "Vänligen välj ett betyg.", errorReview: "Vänligen skriv din recension.", pendingBadge: "Väntar på Godkännande", to: "till", noReviews: "Inga recensioner ännu. Bli den första!"
      }
    },
  };

  const WIDGET_CSS = `
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap');

    #crw-widget * { box-sizing: border-box; margin: 0; padding: 0; }

    /* ── Root wrapper ── */
    #crw-widget {
      font-family: 'Montserrat', sans-serif;
      background: transparent;
      color: #fff;
      padding: 40px 0 !important;
      display: block !important;
      max-width: 1100px !important;
      margin: 0 auto !important;
      width: 100% !important;
    }

    /* ── Section background ── */
    [data-crw-reviews] {
      background: #202124 !important;
      padding: 40px 0 !important;
    }
    .shopify-section:has([data-crw-reviews]) {
      background: #202124 !important;
    }

    /* ── Title ── */
    #crw-widget .crw-title, .crw-title {
      font-size: 28px !important;
      font-weight: 900 !important;
      text-transform: uppercase;
      letter-spacing: 2px !important;
      color: #fff !important;
      margin-bottom: 10px;
      display: block !important;
      width: auto !important;
      margin-left: 3px !important;
      margin-right: -10px !important;
      padding: 0 !important;
    }

    /* ── Dividers ── */
    #crw-widget .crw-divider, .crw-divider {
      border: none;
      border-bottom: 1px solid #444;
      border-color: #444 !important;
      margin-bottom: 14px;
      display: block !important;
      width: auto !important;
      margin-left: 3px !important;
      margin-right: -40px !important;
    }
    #crw-widget .crw-divider-light, .crw-divider-light {
      border: none;
      border-bottom: 1px solid #3a3a3a;
      border-color: #3a3a3a !important;
      margin: 0 0 20px;
      display: block !important;
      width: auto !important;
      margin-left: 3px !important;
      margin-right: -40px !important;
    }

    /* ── Tabs row ── */
    #crw-widget .crw-tabs-row, .crw-tabs-row {
      display: flex !important;
      justify-content: space-between !important;
      align-items: center !important;
      margin-bottom: 8px;
      padding: 10px 0 !important;
      width: auto !important;
      margin-left: 3px !important;
      margin-right: -40px !important;
    }
    #crw-widget .crw-tabs-right, .crw-tabs-right {
      display: flex !important;
      align-items: center !important;
      gap: 15px !important;
    }
    #crw-widget .crw-tab-btn, .crw-tab-btn {
      background: transparent !important;
      border: none !important;
      color: #ffc439 !important;
      font-family: 'Montserrat', sans-serif;
      font-weight: bold !important;
      font-size: 14px !important;
      text-transform: uppercase;
      cursor: pointer !important;
      padding: 10px 0 !important;
      box-shadow: inset 0 -3px #ffc439 !important;
    }
    #crw-widget .crw-pagination-info, .crw-pagination-info {
      color: #999 !important;
      font-size: 13px !important;
      font-weight: 600;
    }

    /* ── Sort dropdown ── */
    #crw-widget .crw-sort-inline, .crw-sort-inline {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: #ffc439 !important;
      background-color: #ffc439;
      color: #000 !important;
      border: 3px solid #000 !important;
      border-radius: 0 !important;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 10px;
      padding-right: 32px;
      height: 42px;
      line-height: 36px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 800 !important;
      font-size: 12px;
      box-shadow: 4px 4px 0 #000 !important;
      cursor: pointer;
      min-width: 80px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 10px center;
      background-size: 14px;
      box-sizing: border-box;
    }
    #crw-widget select.crw-sort-select.crw-sort-inline {
      height: 42px !important;
      line-height: 36px !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      padding-left: 10px !important;
      padding-right: 32px !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 10px center !important;
      background-size: 14px !important;
      background-color: #ffc439 !important;
      color: #000000 !important;
      border: 3px solid #000000 !important;
      box-shadow: 4px 4px 0px #000000 !important;
      font-weight: 800 !important;
      border-radius: 0px !important;
      box-sizing: border-box !important;
    }

    /* ── Layout ── */
    #crw-widget .crw-body, .crw-body {
      display: grid !important;
      grid-template-columns: 33.33% 66.66% !important;
      gap: 40px !important;
      width: 100% !important;
    }
    @media (max-width: 768px) {
      .crw-body { grid-template-columns: 1fr; }
    }

    /* ── Left panel ── */
    #crw-widget .crw-left-panel, .crw-left-panel {
      position: sticky;
      top: 20px;
      align-self: start;
      text-align: center !important;
      padding: 0 10px !important;
      margin-top: 30px !important;
    }
    #crw-widget .crw-score-wrap, .crw-score-wrap {
      display: flex;
      align-items: flex-start;
      justify-content: center !important;
      line-height: 1;
      margin-bottom: 4px;
    }
    #crw-widget .crw-avg-score, .crw-avg-score {
      font-size: 82px !important;
      font-weight: 900 !important;
      color: #ffc439;
      line-height: 1 !important;
    }
    #crw-widget .crw-avg-denom, .crw-avg-denom {
      font-size: 18px !important;
      font-weight: 700;
      color: #999;
      margin-top: 43px !important;
      margin-left: 3px;
    }

    /* ── Star Rating System ── */
    #crw-widget .crw-stars-container, .crw-stars-container {
      position: relative;
      display: inline-block;
      line-height: 1;
      margin-bottom: 16px !important;
    }
    .crw-stars-back, .crw-stars-front {
      display: flex;
      gap: 3px;
    }
    .crw-stars-back { color: #555; }
    .crw-stars-front {
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      color: #ffc439;
      white-space: nowrap;
    }
    .crw-stars-container i {
      font-size: 15px;
      display: inline-block;
    }
    .crw-stars-small i { font-size: 18px; }
    #crw-widget .crw-stars-row, .crw-stars-row {
      display: flex;
      justify-content: center !important;
      margin: 4px 0 !important;
    }
    #crw-widget .crw-star-icon {
      color: #ffc439 !important;
      font-size: 18px !important;
    }
    #crw-widget .crw-star-icon.empty {
      color: #555 !important;
    }

    #crw-widget .crw-from-label, .crw-from-label {
      color: #999;
      font-size: 15px !important;
      letter-spacing: 1px !important;
      margin-top: 6px;
      margin-bottom: 14px !important;
      text-align: center !important;
    }
    #crw-widget .crw-ratings-title, .crw-ratings-title {
      font-weight: 700 !important;
      font-size: 17px !important;
      text-align: center !important;
      color: #fff !important;
      padding-top: 15px !important;
      margin-bottom: 10px !important;
    }

    /* ── Bar rows ── */
    #crw-widget .crw-bar-row, .crw-bar-row {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
      margin-bottom: 5px !important;
      padding: 0 5px !important;
      cursor: pointer;
    }
    .crw-bar-row:hover .crw-bar-fill { background: #ffd966; }
    #crw-widget .crw-bar-label, .crw-bar-label {
      color: #999 !important;
      font-size: 13px;
      font-weight: 700;
      min-width: 45px !important;
      text-align: right !important;
      display: flex;
      align-items: center;
      gap: 3px;
    }
    #crw-widget .crw-bar-track, .crw-bar-track {
      flex-grow: 1 !important;
      height: 8px !important;
      background: #444 !important;
      border-radius: 20px !important;
      overflow: hidden;
    }
    #crw-widget .crw-bar-fill, .crw-bar-fill {
      height: 100%;
      background: #ffc439;
      border-radius: 20px !important;
      transition: width 0.5s ease;
    }
    #crw-widget .crw-bar-count-pill, .crw-bar-count-pill {
      background: #1a1a1a !important;
      color: #fff !important;
      border: 1px solid #555 !important;
      border-radius: 11px !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      min-width: 26px !important;
      height: 22px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 0 6px !important;
    }

    /* ── Write a review button ── */
    #crw-widget .crw-write-btn, .crw-write-btn {
      display: block;
      width: 100% !important;
      margin-top: 16px !important;
      background: #ffc439 !important;
      color: #000 !important;
      font-family: 'Montserrat', sans-serif;
      font-weight: 800 !important;
      font-size: 19px !important;
      letter-spacing: 2px;
      text-transform: uppercase !important;
      border: 3px solid #000 !important;
      border-radius: 0 !important;
      padding: 14px 20px !important;
      box-shadow: 4px 4px 0px #000 !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      text-align: center !important;
    }
    #crw-widget .crw-write-btn:hover, .crw-write-btn:hover {
      background-color: #ffe066 !important;
      transform: translate(2px, 2px) !important;
      box-shadow: 2px 2px 0px #000000 !important;
    }
    #crw-widget .crw-write-btn:active, .crw-write-btn:active {
      transform: translate(4px, 4px) !important;
      box-shadow: 0px 0px 0px #000000 !important;
    }

    /* ── Right panel ── */
    #crw-widget .crw-right-panel, .crw-right-panel {
      max-width: 850px !important;
      margin-top: 15px !important;
    }

    /* ── Review cards ── */
    #crw-widget .crw-review-card, .crw-review-card {
      background: #2b2b2f !important;
      border: 3px solid #000 !important;
      border-radius: 0px !important;
      box-shadow: 6px 6px 0px #000 !important;
      margin-bottom: 35px !important;
      padding: 30px !important;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;
      animation: crwFadeIn 0.4s ease both;
    }
    #crw-widget .crw-review-card:hover, .crw-review-card:hover {
      border-color: #ffc439 !important;
      box-shadow: 8px 8px 0px #ffc439 !important;
    }
    @keyframes crwFadeIn {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .crw-review-card.crw-pending {
      border-color: #444 !important;
      opacity: 0.8;
    }
    #crw-widget .crw-reviews-list .crw-review-card:first-child {
      margin-top: 15px !important;
    }

    /* ── Card header ── */
    #crw-widget .crw-card-header, .crw-card-header {
      display: flex !important;
      justify-content: space-between !important;
      align-items: flex-start !important;
      margin-bottom: 18px !important;
    }
    #crw-widget .crw-reviewer-info, .crw-reviewer-info {
      display: flex !important;
      align-items: center !important;
      gap: 12px !important;
    }
    #crw-widget .crw-avatar, .crw-avatar {
      width: 38px !important;
      height: 38px !important;
      border-radius: 50% !important;
      background: linear-gradient(135deg, #3498db, #2980b9) !important;
      color: #000 !important;
      font-weight: 900 !important;
      font-size: 13px !important;
      border: none !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex-shrink: 0;
    }
    #crw-widget .crw-reviewer-name, .crw-reviewer-name {
      font-weight: 700 !important;
      font-size: 14px !important;
      color: #fff !important;
    }
    #crw-widget .crw-verified, .crw-verified {
      color: #ffc439 !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      display: flex;
      align-items: center;
      gap: 3px;
      margin-top: 2px;
    }
    #crw-widget .crw-review-date, .crw-review-date {
      color: #999 !important;
      font-size: 12px !important;
      font-weight: 600;
    }
    .crw-pending-badge {
      background: #333;
      color: #aaa;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1px;
      padding: 3px 8px;
      text-transform: uppercase;
      border: 1px solid #555;
    }

    /* ── Stars container in card ── */
    .crw-stars-container.card-stars {
      margin-bottom: 16px;
    }
    #crw-widget .crw-card-stars span {
      color: #ffc439 !important;
      font-size: 14px !important;
    }
    #crw-widget .crw-card-stars span.empty {
      color: #555 !important;
    }

    /* ── Review body text ── */
    #crw-widget .crw-review-body, .crw-review-body {
      color: #ccc !important;
      font-size: 14px !important;
      font-weight: 500;
      line-height: 1.5 !important;
      margin-top: 12px !important;
      margin-bottom: 24px !important;
    }

    /* ── Images ── */
    .crw-images-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 12px;
    }
    .crw-img-thumb {
      width: 80px;
      height: 80px;
      object-fit: cover;
      border: 2px solid #444;
      cursor: pointer;
      transition: border-color 0.15s ease, transform 0.15s ease;
    }
    .crw-img-thumb:hover { border-color: #ffc439; transform: scale(1.05); }

    /* ── Card footer ── */
    #crw-widget .crw-card-footer, .crw-card-footer {
      border-top: 2px solid #fff !important;
      padding-top: 18px !important;
      margin-top: 18px !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    #crw-widget .crw-like-btn, .crw-like-btn {
      background: transparent;
      border: 1px solid #444;
      border-color: #444 !important;
      color: #777 !important;
      font-family: 'Montserrat', sans-serif;
      font-size: 12px;
      font-weight: 700;
      padding: 4px 10px;
      cursor: pointer;
      transition: all 0.15s ease;
      display: flex;
      align-items: center;
      gap: 5px;
      border-radius: 15px !important;
    }
    .crw-like-btn:hover, .crw-like-btn.active {
      border-color: #ffc439;
      color: #ffc439;
    }

    /* ── Load More ── */
    .crw-load-more-wrap { text-align: center; margin-top: 30px; }
    #crw-widget .crw-load-more-btn, .crw-load-more-btn {
      display: block !important;
      margin: 30px auto 0 !important;
      background: #373737 !important;
      color: #fff !important;
      font-family: 'Montserrat', sans-serif;
      font-weight: 800;
      font-size: 16px !important;
      letter-spacing: 1px;
      text-transform: uppercase;
      border: 1px solid #bebebe !important;
      border-radius: 5px !important;
      padding: 12px 38px !important;
      cursor: pointer !important;
      transition: opacity 0.2s ease !important;
    }
    #crw-widget .crw-load-more-btn:hover, .crw-load-more-btn:hover { opacity: 0.8 !important; }

    /* ── Lightbox ── */
    .crw-lightbox-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.92);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .crw-lightbox-inner {
      position: relative;
      max-width: 90vw;
      max-height: 90vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .crw-lightbox-img {
      min-width: min(85vw, 85vh);
      min-height: min(85vw, 85vh);
      max-width: 90%;
      max-height: 90vh;
      object-fit: contain;
      display: block;
    }
    .crw-lightbox-close {
      position: absolute;
      top: -36px;
      right: 0;
      background: none;
      border: none;
      color: #fff;
      font-size: 28px;
      cursor: pointer;
      font-weight: 900;
      line-height: 1;
    }
    .crw-lightbox-prev, .crw-lightbox-next {
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255,255,255,0.1);
      border: 2px solid rgba(255,255,255,0.3);
      color: #fff;
      font-size: 28px;
      font-weight: 900;
      width: 52px;
      height: 52px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.15s ease;
    }
    .crw-lightbox-prev:hover, .crw-lightbox-next:hover { background: rgba(255,196,57,0.3); }
    .crw-lightbox-prev { left: 20px; }
    .crw-lightbox-next { right: 20px; }

    /* ── Write Review Form ── */
    #crw-widget .crw-form-wrap, .crw-form-wrap {
      display: none;
      background: #2b2b2f !important;
      border: 3px solid #444444 !important;
      border-radius: 0px !important;
      padding: 30px !important;
      margin-top: 25px !important;
      margin-bottom: 16px;
      box-sizing: border-box !important;
      box-shadow: 0px 0px 0px 5px #ffc439 !important; 
    }
    .crw-form-wrap.open { display: block; animation: crwFadeIn 0.3s ease; }

    #crw-widget .crw-form-title, .crw-form-title {
      color: #ffffff !important;
      font-size: 22px !important;
      font-weight: 900 !important;
      text-transform: uppercase !important;
      letter-spacing: 1px !important;
      margin-bottom: 25px !important;
      border-bottom: 2px solid #444444 !important;
      padding-bottom: 12px !important;
    }
    #crw-widget .crw-form-field, .crw-form-field {
      margin-bottom: 22px !important;
      display: flex !important;
      flex-direction: column !important;
    }
    #crw-widget .crw-form-label, .crw-form-label {
      display: block;
      font-size: 13px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.5px !important;
      color: #999999 !important;
      margin-bottom: 8px !important;
    }
    #crw-widget .crw-form-input, #crw-widget .crw-form-textarea, .crw-form-input, .crw-form-textarea {
      width: 100% !important;
      background: #1a1a1a !important;
      border: 2px solid #444444 !important;
      color: #fff !important;
      font-family: 'Montserrat', sans-serif;
      font-size: 14px !important;
      font-weight: 500;
      padding: 12px 14px !important;
      outline: none;
      border-radius: 0px !important;
      box-sizing: border-box !important;
      width: 100% !important;
      transition: border-color 0.15s ease-in-out !important;
    }
    #crw-widget .crw-form-input:focus, #crw-widget .crw-form-textarea:focus, .crw-form-input:focus, .crw-form-textarea:focus { border-color: #ffc439 !important; }
    .crw-form-textarea {
      resize: vertical !important;
      min-height: 110px !important;
    }

    #crw-widget .crw-star-select, .crw-star-select {
      display: flex !important;
      gap: 6px !important;
      margin-top: 2px !important;
      font-size: 26px !important;
      color: #ffc439 !important;
      cursor: pointer !important;
    }
    .crw-star-select span {
      font-size: 26px;
      cursor: pointer;
      color: #555;
      transition: color 0.1s ease, transform 0.1s ease;
      user-select: none;
    }
    .crw-star-select span.lit { color: #ffc439; }
    .crw-star-select span:hover { transform: scale(1.2); }

    #crw-widget .crw-file-label, .crw-file-label {
      background: #373737 !important;
      color: #ffffff !important;
      border: 1px dashed #666666 !important;
      border-radius: 4px !important;
      padding: 14px !important;
      text-align: center !important;
      font-size: 13px !important;
      font-weight: bold !important;
      cursor: pointer !important;
      display: block !important;
      transition: background 0.15s ease !important;
    }
    #crw-widget .crw-file-label:hover, .crw-file-label:hover { background: #444444 !important; }
    #crw-widget .crw-file-input, .crw-file-input { display: none !important; }
    .crw-file-preview { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; }
    .crw-file-preview img {
      width: 60px; height: 60px;
      object-fit: cover;
      border: 2px solid #444;
    }

    #crw-widget .crw-form-submit, .crw-form-submit {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: auto !important;
      min-width: 180px !important;
      height: 46px !important;
      margin-top: 10px !important;
      padding: 0 30px !important;
      background-color: #ffc439 !important;
      color: #000000 !important;
      font-family: 'Montserrat', sans-serif;
      font-size: 14px !important;
      font-weight: 900 !important;
      text-transform: uppercase !important;
      letter-spacing: 1px !important;
      border: 3px solid #000000 !important;
      box-shadow: 4px 4px 0px #000000 !important;
      border-radius: 0px !important;
      cursor: pointer !important;
      transition: all 0.1s ease-in-out !important;
    }
    #crw-widget .crw-form-submit:hover, .crw-form-submit:hover {
      background-color: #ffe066 !important;
      transform: translate(2px, 2px) !important;
      box-shadow: 2px 2px 0px #000000 !important;
    }
    #crw-widget .crw-form-submit:active, .crw-form-submit:active {
      transform: translate(4px, 4px) !important;
      box-shadow: 0px 0px 0px #000000 !important;
    }
    .crw-form-submit:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

    #crw-widget .crw-field-error, .crw-field-error {
      color: #ff4d4d !important;
      font-size: 12px !important;
      font-weight: bold !important;
      margin-top: 6px !important;
    }
    .crw-success-msg {
      background: #1a3d1a;
      border: 2px solid #4caf50;
      color: #a5d6a7;
      padding: 14px;
      font-weight: 700;
      font-size: 14px;
      margin-top: 12px;
      display: none;
    }
    .crw-success-msg.show { display: block; animation: crwFadeIn 0.3s ease; }

.crw-pending-badge {
  display: none !important;
}

    /* ── Loading ── */
    .crw-loading {
      text-align: center;
      padding: 40px;
      color: #666;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 2px;
    }
    .crw-spinner {
      width: 36px; height: 36px;
      border: 4px solid #333;
      border-top-color: #ffc439;
      border-radius: 50%;
      margin: 0 auto 12px;
      animation: crwSpin 0.8s linear infinite;
    }
    @keyframes crwSpin { to { transform: rotate(360deg); } }

    .crw-no-reviews {
      color: #666;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      padding: 40px;
      letter-spacing: 1px;
    }

    /* ── Responsive ── */
    @media (max-width: 560px) {
      .crw-avg-score { font-size: 60px; }
      .crw-title { font-size: 20px; }
      .crw-review-card { padding: 14px; }
      .crw-tabs-right { flex-direction: column; align-items: flex-end; gap: 6px; }
    }

/* ── Form wrapper visibility adjustments ── */
.crw-form-wrap {
  display: none !important; /* Keep hidden by default */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.crw-form-wrap.open {
  display: block !important; /* Reveal when JS toggles .open */
  opacity: 1;
}

@media screen and (max-width: 768px) {
  /* Break the strict desktop two-column grid layout into a stacked layout */
  #crw-widget .crw-body {
    grid-template-columns: 1fr !important;
    gap: 20px !important;
  }

  /* Reset the left panel sticky layout and center contents for mobile */
  #crw-widget .crw-left-panel {
    position: static !important;
    margin-top: 10px !important;
    padding: 0 !important;
  }

  /* Adjust the list view to sit naturally under the score breakdown */
  #crw-widget .crw-right-panel {
    margin-top: 10px !important;
  }

  /* Clean up card dimensions and excessive margins */
  #crw-widget .crw-review-card {
    padding: 20px !important;
    margin-bottom: 20px !important;
  }

  /* Prevent elements from stretching past screen viewports */
  #crw-widget {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  /* Stack layout row controls (Sort filter controls, tabs) */
  #crw-widget .crw-tabs-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
    margin-right: 0 !important;
  }

  #crw-widget .crw-tabs-right {
    justify-content: space-between !important;
  }

  /* Force inline review selectors to adjust elements evenly */
  #crw-widget .crw-card-header {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  /* Adjust form fields inside your "Write A Review" toggle wrapper */
  #crw-widget .crw-form-wrap {
    padding: 15px !important;
  }
 
}

  `;

  /* ─── HELPERS ─── */
  function getLocale() {
    let loc = "en";
    if (window.Shopify && window.Shopify.locale) {
      loc = window.Shopify.locale;
    } else if (document.documentElement.lang) {
      loc = document.documentElement.lang;
    }
    return loc.toLowerCase();
  }
  
  function getT() {
    const locale = getLocale();
    if (WIDGET_CONFIG.UI_TEXT[locale]) return WIDGET_CONFIG.UI_TEXT[locale];
    const prefix = locale.split("-")[0];
    if (WIDGET_CONFIG.UI_TEXT[prefix]) return WIDGET_CONFIG.UI_TEXT[prefix];
    return WIDGET_CONFIG.UI_TEXT["en"];
  }
  
  function getBodyColumn() {
    const locale = getLocale();
    if (WIDGET_CONFIG.LOCALE_COLUMN_MAP[locale]) return WIDGET_CONFIG.LOCALE_COLUMN_MAP[locale];
    const prefix = locale.split("-")[0];
    if (WIDGET_CONFIG.LOCALE_COLUMN_MAP[prefix]) return WIDGET_CONFIG.LOCALE_COLUMN_MAP[prefix];
    return "body";
  }

  function stars(rating) {
    const percentage = (rating / 5) * 100;
    return `
      <div class="crw-stars-container">
        <div class="crw-stars-back">
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
        </div>
        <div class="crw-stars-front" style="width:${percentage.toFixed(2)}%">
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
        </div>
      </div>`;
  }

  function starsSmall(rating) {
    const percentage = (rating / 5) * 100;
    return `
      <div class="crw-stars-container crw-stars-small">
        <div class="crw-stars-back">
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
        </div>
        <div class="crw-stars-front" style="width:${percentage.toFixed(2)}%">
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
          <i class="fas fa-star" aria-hidden="true"></i>
        </div>
      </div>`;
  }

  function maskName(name) {
    if (!name) return "Anonymous";
    const parts = name.trim().split(" ");
    return parts.map(p => p.length <= 1 ? p : p[0] + "***" + p[p.length - 1]).join(" ");
  }
  function initials(name) {
    if (!name) return "?";
    return name.trim().split(" ").slice(0, 2).map(p => p[0] || "").join("").toUpperCase();
  }
  function formatDate(dateStr) {
    if (!dateStr) return "";
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    } catch (e) { return dateStr; }
  }

  function parseCSV(text) {
    const rows = [];
    const lines = text.split(/\r?\n/);
    if (!lines.length) return rows;
    function parseLine(line) {
      const result = [];
      let cell = "", inQuotes = false;
      for (let i = 0; i < line.length; i++) {
        const ch = line[i];
        if (ch === '"') {
          if (inQuotes && line[i + 1] === '"') { cell += '"'; i++; }
          else inQuotes = !inQuotes;
        } else if (ch === "," && !inQuotes) {
          result.push(cell.trim()); cell = "";
        } else { cell += ch; }
      }
      result.push(cell.trim());
      return result;
    }
    const headers = parseLine(lines[0]).map(h => h.replace(/^\uFEFF/, "").trim());
    for (let i = 1; i < lines.length; i++) {
      if (!lines[i].trim()) continue;
      const vals = parseLine(lines[i]);
      const obj = {};
      headers.forEach((h, idx) => { obj[h] = vals[idx] || ""; });
      rows.push(obj);
    }
    return rows;
  }

  function getUserId() {
    let id = localStorage.getItem("crw_user_id");
    if (!id) {
      id = "usr_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem("crw_user_id", id);
    }
    return id;
  }

  function getPendingReviews() {
    try { return JSON.parse(localStorage.getItem("crw_pending") || "[]"); }
    catch (e) { return []; }
  }

  /* ─── MAIN WIDGET CLASS ─── */
  class ReviewsWidget {
    constructor(container, productHandle) {
      this.container = container;
      this.productHandle = productHandle;
      this.allReviews = [];
      this.filteredReviews = [];
      this.currentPage = 1;
      this.sortMode = "images";
      this.activeFilter = null;
      this.lightboxImages = [];
      this.lightboxIndex = 0;
      this.userId = getUserId();
      this.t = getT();
      this.bodyCol = getBodyColumn();
      this.injectCSS();
      this.render();
      this.loadReviews();
    }

    injectCSS() {
      if (!document.getElementById("crw-fontawesome")) {
        const faLink = document.createElement("link");
        faLink.id = "crw-fontawesome";
        faLink.rel = "stylesheet";
        faLink.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";
        document.head.appendChild(faLink);
      }
      if (document.getElementById("crw-styles")) return;
      const style = document.createElement("style");
      style.id = "crw-styles";
      style.textContent = WIDGET_CSS;
      document.head.appendChild(style);
    }

 async loadReviews() {
  const listEl = this.container.querySelector(".crw-reviews-list");

  // ── Cache check ──────────────────────────────────────────
  const cacheKey = "crw_cache_" + this.productHandle;
  const cacheTsKey = "crw_cache_ts_" + this.productHandle;
  const CACHE_TTL = 60 * 60 * 1000; // 1 hour

  const cachedData = localStorage.getItem(cacheKey);
  const cachedTs = parseInt(localStorage.getItem(cacheTsKey) || "0");

  if (cachedData && (Date.now() - cachedTs < CACHE_TTL)) {
    try {
      const sheetReviews = JSON.parse(cachedData);
      this._mergeAndRender(sheetReviews);
      return;
    } catch (e) {
      // Cache corrupt, fall through to fetch
    }
  }

    // ── Fetch from GitHub ────────────────────────────────────
  if (listEl) listEl.innerHTML = `<div class="crw-loading"><div class="crw-spinner"></div>Loading reviews...</div>`;

  try {
    const baseUrl = WIDGET_CONFIG.REVIEWS_URL;
    let url = baseUrl + encodeURIComponent(this.productHandle) + ".json";
    console.log("[CRW] Fetching:", url);
    let resp = await fetch(url);
    console.log("[CRW] Response status:", resp.status);

    if (resp.status === 404) {
      const fallbackUrl = baseUrl + "default-reviews.json";
      console.log("[CRW] Product not found, trying fallback:", fallbackUrl);
      const fallbackResp = await fetch(fallbackUrl);
      console.log("[CRW] Fallback response status:", fallbackResp.status);

      if (fallbackResp.status === 404) {
        console.log("[CRW] No fallback found, rendering empty.");
        this._mergeAndRender([]);
        return;
      }

      if (!fallbackResp.ok) throw new Error("Failed to fetch fallback, status: " + fallbackResp.status);
      const fallbackReviews = await fallbackResp.json();
      console.log("[CRW] Fallback reviews loaded, count:", fallbackReviews.length);

      try {
        localStorage.setItem("crw_cache_" + this.productHandle, JSON.stringify(fallbackReviews));
        localStorage.setItem("crw_cache_ts_" + this.productHandle, String(Date.now()));
      } catch (e) { console.log("[CRW] Cache save failed:", e.message); }

      this._mergeAndRender(fallbackReviews);
      return;
    }

    if (!resp.ok) throw new Error("Failed to fetch, status: " + resp.status);
    const sheetReviews = await resp.json();
    console.log("[CRW] Reviews loaded, count:", sheetReviews.length);

    try {
      localStorage.setItem("crw_cache_" + this.productHandle, JSON.stringify(sheetReviews));
      localStorage.setItem("crw_cache_ts_" + this.productHandle, String(Date.now()));
    } catch (e) { console.log("[CRW] Cache save failed:", e.message); }

    this._mergeAndRender(sheetReviews);

  } catch (e) {
    console.log("[CRW] Error in loadReviews:", e.message);
    if (listEl) listEl.innerHTML = `<div class="crw-no-reviews">Unable to load reviews at this time.</div>`;
  }
}

_mergeAndRender(sheetReviews) {
  const localPending = getPendingReviews().filter(r => r.product_handle === this.productHandle);

  this.allReviews = sheetReviews.filter(r => {
    const isDuplicate = localPending.some(local => {
      const sheetEmail = (r.reviewer_email || "").toLowerCase().trim();
      const sheetBody = (r.body || "").toLowerCase().trim();
      const localEmail = (local.reviewer_email || "").toLowerCase().trim();
      const localBody = (local.body || "").toLowerCase().trim();
      return sheetEmail === localEmail && sheetBody === localBody;
    });
    if (isDuplicate) return false;
    if ((r.status || "").toLowerCase() === "pending") return false;
    return true;
  });

  localPending.forEach(r => {
    if (!this.allReviews.find(existing => existing._localId && existing._localId === r._localId)) {
      this.allReviews.unshift(r);
    }
  });

  this.applySort();
  this.renderStats();
  this.renderReviews();
}

    applySort() {
      let reviews = [...this.allReviews];
      if (this.activeFilter) {
        reviews = reviews.filter(r => parseInt(r.rating) === this.activeFilter);
      }
      if (this.sortMode === "date") {
        reviews.sort((a, b) => new Date(b.review_date || 0) - new Date(a.review_date || 0));
      } else if (this.sortMode === "stars") {
        reviews.sort((a, b) => parseInt(b.rating) - parseInt(a.rating));
      } else if (this.sortMode === "stars_old") {
        reviews.sort((a, b) => parseInt(a.rating) - parseInt(b.rating));
      } else if (this.sortMode === "images") {
        // Tier 0 = has image(s), Tier 1 = has text but no image, Tier 2 = neither.
        const tier = (r) => {
          const hasImg = !!(r.picture_urls && String(r.picture_urls).trim());
          if (hasImg) return 0;
          const hasText = !!((r[this.bodyCol] || r.body || "").trim());
          return hasText ? 1 : 2;
        };
        reviews.sort((a, b) => tier(a) - tier(b));
      }
      this.filteredReviews = reviews;
    }

    getVisible() {
      return this.filteredReviews.filter(r => {
        if (!r.status || r.status.toLowerCase() !== "pending") return true;
        return r.user_identifier === this.userId || r._localId;
      });
    }

    renderStats() {
      const publicReviews = this.allReviews.filter(r =>
        !r.status || r.status.toLowerCase() !== "pending" ||
        r.user_identifier === this.userId || r._localId
      );
      const total = publicReviews.length;
      const avg = total ? (publicReviews.reduce((s, r) => s + parseInt(r.rating || 0), 0) / total) : 0;
      const counts = [0, 0, 0, 0, 0];
      publicReviews.forEach(r => { const s = parseInt(r.rating); if (s >= 1 && s <= 5) counts[s - 1]++; });

      const avgEl = this.container.querySelector(".crw-avg-score");
      if (avgEl) avgEl.textContent = total ? avg.toFixed(1) : "—";

      const fromEl = this.container.querySelector(".crw-from-label");
      if (fromEl) fromEl.textContent = `${this.t.from} ${total} ${this.t.reviewsLabel}`;

      const starsEl = this.container.querySelector(".crw-avg-stars");
      if (starsEl) starsEl.innerHTML = starsSmall(Math.round(avg));

      for (let s = 1; s <= 5; s++) {
        const bar = this.container.querySelector(`.crw-bar-fill[data-star="${s}"]`);
        const cnt = this.container.querySelector(`.crw-bar-count-pill[data-star="${s}"]`);
        if (bar) bar.style.width = total ? `${(counts[s - 1] / total) * 100}%` : "0%";
        if (cnt) cnt.textContent = counts[s - 1];
      }

      const tabBtn = this.container.querySelector(".crw-tab-btn");
      if (tabBtn) tabBtn.textContent = `${this.t.reviews} (${total})`;
    }

    renderReviews() {
      const visible = this.getVisible();
      const perPage = WIDGET_CONFIG.REVIEWS_PER_PAGE;
      const total = visible.length;
      const showing = Math.min(this.currentPage * perPage, total);
      const listEl = this.container.querySelector(".crw-reviews-list");
      if (!listEl) return;
      if (!total) {
        listEl.innerHTML = `<div class="crw-no-reviews">${this.t.noReviews}</div>`;
        return;
      }
      const pageItems = visible.slice(0, showing);
      listEl.innerHTML = pageItems.map((r, idx) => this.renderCard(r, idx)).join("");
      const lmWrap = this.container.querySelector(".crw-load-more-wrap");
      if (lmWrap) lmWrap.style.display = showing < total ? "block" : "none";
      this.bindCardEvents();
    }

    renderCard(r, idx) {
      const isPending = r.status && r.status.toLowerCase() === "pending";
      const bodyText = r[this.bodyCol] || r["body"] || "";
      const picUrls = (r["picture_urls"] || "").split(",").map(u => u.trim()).filter(Boolean);
      const name = r["reviewer_name"] || "Anonymous";
      const masked = maskName(name);
      const ini = initials(name);
      const date = formatDate(r["review_date"]);
      const rating = parseInt(r["rating"]) || 5;

      return `
        <div class="crw-review-card${isPending ? " crw-pending" : ""}" data-idx="${idx}">
          <div class="crw-card-header">
            <div class="crw-reviewer-info">
              <div class="crw-avatar">${ini}</div>
              <div>
                <div class="crw-reviewer-name">${masked}</div>
                ${!isPending ? `<div class="crw-verified">&#10003; ${this.t.verified}</div>` : `<div class="crw-pending-badge">${this.t.pendingBadge}</div>`}
              </div>
            </div>
            ${date ? `<div class="crw-review-date" style="display: none !important;">${date}</div>` : ""}
          </div>
          ${stars(rating)}
          ${bodyText ? `<div class="crw-review-body">${bodyText}</div>` : ""}
          ${picUrls.length ? `<div class="crw-images-grid">${picUrls.map((u, i) =>
            `<img class="crw-img-thumb" src="${u}" alt="Review image ${i + 1}"
              data-gallery='${JSON.stringify(picUrls)}' data-gidx="${i}" loading="lazy">`
          ).join("")}</div>` : ""}
          <div class="crw-card-footer">
            <button class="crw-like-btn" data-review-idx="${idx}">
              &#128077; <span class="crw-like-count">${r._likes || 0}</span>
            </button>
          </div>
        </div>`;
    }

    bindCardEvents() {
      this.container.querySelectorAll(".crw-img-thumb").forEach(img => {
        img.addEventListener("click", () => {
          const gallery = JSON.parse(img.dataset.gallery || "[]");
          const idx = parseInt(img.dataset.gidx || "0");
          this.openLightbox(gallery, idx);
        });
      });
      this.container.querySelectorAll(".crw-like-btn").forEach(btn => {
        btn.addEventListener("click", () => {
          const liked = JSON.parse(localStorage.getItem("crw_liked") || "{}");
          const key = btn.dataset.reviewIdx;
          if (liked[key]) return;
          liked[key] = true;
          localStorage.setItem("crw_liked", JSON.stringify(liked));
          const cnt = btn.querySelector(".crw-like-count");
          if (cnt) cnt.textContent = parseInt(cnt.textContent || 0) + 1;
          btn.classList.add("active");
        });
      });
    }

    openLightbox(images, startIdx) {
      this.lightboxImages = images;
      this.lightboxIndex = startIdx;
      const overlay = document.createElement("div");
      overlay.className = "crw-lightbox-overlay";
      overlay.innerHTML = `
        <div class="crw-lightbox-inner">
          <button class="crw-lightbox-close">&#10005;</button>
          <img class="crw-lightbox-img" src="${images[startIdx]}" alt="">
        </div>
        ${images.length > 1 ? `
          <button class="crw-lightbox-prev">&#8592;</button>
          <button class="crw-lightbox-next">&#8594;</button>
        ` : ""}`;
      document.body.appendChild(overlay);
      document.body.style.overflow = "hidden";
      const imgEl = overlay.querySelector(".crw-lightbox-img");
      overlay.querySelector(".crw-lightbox-close").addEventListener("click", () => this.closeLightbox(overlay));
      overlay.addEventListener("click", e => { if (e.target === overlay) this.closeLightbox(overlay); });
      const prev = overlay.querySelector(".crw-lightbox-prev");
      const next = overlay.querySelector(".crw-lightbox-next");
      if (prev) prev.addEventListener("click", () => {
        this.lightboxIndex = (this.lightboxIndex - 1 + images.length) % images.length;
        imgEl.src = images[this.lightboxIndex];
      });
      if (next) next.addEventListener("click", () => {
        this.lightboxIndex = (this.lightboxIndex + 1) % images.length;
        imgEl.src = images[this.lightboxIndex];
      });
      const keyHandler = e => {
        if (e.key === "Escape") this.closeLightbox(overlay);
        if (e.key === "ArrowLeft" && prev) prev.click();
        if (e.key === "ArrowRight" && next) next.click();
      };
      document.addEventListener("keydown", keyHandler);
      overlay._keyHandler = keyHandler;
    }

    closeLightbox(overlay) {
      document.removeEventListener("keydown", overlay._keyHandler);
      overlay.remove();
      document.body.style.overflow = "";
    }

    render() {
      const t = this.t;
      this.container.innerHTML = `
        <div id="crw-widget">
          <div class="crw-title">${t.title}</div>
          <hr class="crw-divider">
          <div class="crw-tabs-row">
            <button class="crw-tab-btn">${t.reviews} (0)</button>
            <div class="crw-tabs-right">
              <div class="crw-pagination-info"></div>
              <select class="crw-sort-select crw-sort-inline">
                <option value="date">${t.sortLabel}</option>
                <option value="date">${t.sortRecent}</option>
                <option value="stars">${t.sortHigh}</option>
                <option value="stars_old">${t.sortLow}</option>
                <option value="images">${t.sortPhotos}</option>
              </select>
            </div>
          </div>
          <hr class="crw-divider-light">
          <div class="crw-body">
            <!-- LEFT PANEL -->
            <div class="crw-left-panel">
              <div class="crw-score-wrap">
                <span class="crw-avg-score">—</span><span class="crw-avg-denom">/5</span>
              </div>
              <div class="crw-stars-row"><div class="crw-avg-stars"></div></div>
              <div class="crw-from-label">${t.from} 0 ${t.reviewsLabel}</div>
              <div class="crw-ratings-title">${t.customersRatings}</div>
              ${[5,4,3,2,1].map(s => `
                <div class="crw-bar-row" data-filter="${s}">
                  <div class="crw-bar-label">${s} &#9733;</div>
                  <div class="crw-bar-track"><div class="crw-bar-fill" data-star="${s}" style="width:0%"></div></div>
                  <div class="crw-bar-count-pill" data-star="${s}">0</div>
                </div>`).join("")}
              <button class="crw-write-btn">${t.writeReview}</button>
            </div>
            <!-- RIGHT PANEL -->
            <div class="crw-right-panel">
              <!-- Write Review Form -->
              <div class="crw-form-wrap">
                <div class="crw-form-title">${t.writeReview}</div>
                <div class="crw-form-field">
                  <label class="crw-form-label">${t.yourName}</label>
                  <input class="crw-form-input crw-input-name" type="text" placeholder="${t.yourNamePlaceholder}">
                  <div class="crw-field-error crw-err-name" style="display:none">${t.errorName}</div>
                </div>
                <div class="crw-form-field">
                  <label class="crw-form-label">${t.email}</label>
                  <input class="crw-form-input crw-input-email" type="email" placeholder="${t.emailPlaceholder}">
                </div>
                <div class="crw-form-field">
                  <label class="crw-form-label">${t.yourRating}</label>
                  <div class="crw-star-select">
                    ${[1,2,3,4,5].map(i => `<span data-val="${i}">&#9733;</span>`).join("")}
                  </div>
                  <div class="crw-field-error crw-err-rating" style="display:none">${t.errorRating}</div>
                </div>
                <div class="crw-form-field">
                  <label class="crw-form-label">${t.yourReview}</label>
                  <textarea class="crw-form-textarea crw-input-review" placeholder="${t.yourReviewPlaceholder}"></textarea>
                  <div class="crw-field-error crw-err-review" style="display:none">${t.errorReview}</div>
                </div>
                <div class="crw-form-field">
                  <label class="crw-form-label">${t.addPhotos}</label>
                  <label class="crw-file-label">
                    &#128247; ${t.addPhotos}
                    <input class="crw-file-input" type="file" accept="image/*" multiple>
                  </label>
                  <div class="crw-file-preview"></div>
                </div>
                <button class="crw-form-submit">${t.submit}</button>
                <div class="crw-success-msg">${t.successMsg}</div>
              </div>
              <div class="crw-reviews-list">
                <div class="crw-loading"><div class="crw-spinner"></div>Loading...</div>
              </div>
              <div class="crw-load-more-wrap" style="display:none">
                <button class="crw-load-more-btn">${t.loadMore}</button>
              </div>
            </div>
          </div>
        </div>`;
      this.bindStaticEvents();
    }

    bindStaticEvents() {
      const t = this.t;

      // Sort
      const sortSel = this.container.querySelector(".crw-sort-inline");
      sortSel.addEventListener("change", () => {
        this.sortMode = sortSel.value;
        this.currentPage = 1;
        this.applySort();
        this.renderReviews();
      });

      // Filter by star bars
      this.container.querySelectorAll(".crw-bar-row").forEach(row => {
        row.addEventListener("click", () => {
          const val = parseInt(row.dataset.filter);
          this.activeFilter = this.activeFilter === val ? null : val;
          this.currentPage = 1;
          this.applySort();
          this.renderReviews();
        });
      });

      // Write review toggle
      const writeBtn = this.container.querySelector(".crw-write-btn");
      const formWrap = this.container.querySelector(".crw-form-wrap");
      writeBtn.addEventListener("click", () => {
        formWrap.classList.toggle("open");
        if (formWrap.classList.contains("open")) {
          formWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });

      // Load more
      const lmBtn = this.container.querySelector(".crw-load-more-btn");
      lmBtn.addEventListener("click", () => { this.currentPage++; this.renderReviews(); });

      // Star selector
      let selectedRating = 0;
      const starSpans = this.container.querySelectorAll(".crw-star-select span");
      starSpans.forEach(span => {
        span.addEventListener("mouseenter", () => {
          const val = parseInt(span.dataset.val);
          starSpans.forEach(s => s.classList.toggle("lit", parseInt(s.dataset.val) <= val));
        });
        span.addEventListener("mouseleave", () => {
          starSpans.forEach(s => s.classList.toggle("lit", parseInt(s.dataset.val) <= selectedRating));
        });
        span.addEventListener("click", () => {
          selectedRating = parseInt(span.dataset.val);
          starSpans.forEach(s => s.classList.toggle("lit", parseInt(s.dataset.val) <= selectedRating));
        });
      });

      // File input — show local previews immediately while files are staged for upload
      const fileInput = this.container.querySelector(".crw-file-input");
      const preview = this.container.querySelector(".crw-file-preview");
      let stagedFiles = []; // raw File objects, uploaded to Drive on submit

      fileInput.addEventListener("change", () => {
        preview.innerHTML = "";
        stagedFiles = Array.from(fileInput.files);
        console.log("[CRW] Files staged for upload:", stagedFiles.map(f => f.name));
        stagedFiles.forEach(file => {
          const url = URL.createObjectURL(file);
          const img = document.createElement("img");
          img.src = url;
          preview.appendChild(img);
        });
      });

      // Upload a single File to Google Drive via Apps Script and return the public Drive URL.
      const uploadImageToDrive = async (file) => {
        console.log("[CRW] uploadImageToDrive: reading file as base64:", file.name, file.type, file.size + " bytes");
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error("Failed to read file"));
          reader.readAsDataURL(file);
        });
        console.log("[CRW] base64 ready, length:", base64.length, "— first 80 chars:", base64.substring(0, 80));

        const payload = JSON.stringify({ action: "uploadImage", imageBase64: base64, filename: file.name });
        console.log("[CRW] POSTing to SUBMIT_URL:", WIDGET_CONFIG.SUBMIT_URL);
        console.log("[CRW] Payload size (bytes):", payload.length);

        let response;
        try {
          response = await fetch(WIDGET_CONFIG.SUBMIT_URL, {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: payload,
          });
          console.log("[CRW] fetch response status:", response.status, response.statusText);
          console.log("[CRW] fetch response ok:", response.ok);
        } catch (fetchErr) {
          console.error("[CRW] fetch FAILED (network/CORS error):", fetchErr);
          throw fetchErr;
        }

        let result;
        try {
          const rawText = await response.text();
          console.log("[CRW] Raw response text:", rawText);
          result = JSON.parse(rawText);
          console.log("[CRW] Parsed response:", result);
        } catch (parseErr) {
          console.error("[CRW] Failed to parse response as JSON:", parseErr);
          throw parseErr;
        }

        if (!result.success) {
          console.error("[CRW] Apps Script returned error:", result.error);
          throw new Error(result.error || "Image upload failed");
        }
        console.log("[CRW] Image uploaded successfully. Drive URL:", result.url);
        return result.url;
      };

      // Form submit
      const submitBtn = this.container.querySelector(".crw-form-submit");
      const successMsg = this.container.querySelector(".crw-success-msg");

      submitBtn.addEventListener("click", async () => {
        const name = this.container.querySelector(".crw-input-name").value.trim();
        const email = this.container.querySelector(".crw-input-email").value.trim();
        const reviewText = this.container.querySelector(".crw-input-review").value.trim();

        let valid = true;
        const errName = this.container.querySelector(".crw-err-name");
        const errRating = this.container.querySelector(".crw-err-rating");
        const errReview = this.container.querySelector(".crw-err-review");

        errName.style.display = (!name) ? "block" : "none"; if (!name) valid = false;
        errRating.style.display = (!selectedRating) ? "block" : "none"; if (!selectedRating) valid = false;
        errReview.style.display = (!reviewText) ? "block" : "none"; if (!reviewText) valid = false;
        if (!valid) return;

        console.log("[CRW] Submit clicked. Name:", name, "| Rating:", selectedRating, "| Files staged:", stagedFiles.length);

        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting...";

        // Step 1: Upload any staged images to Google Drive and collect their permanent URLs.
        let driveImageUrls = [];
        if (stagedFiles.length > 0) {
          submitBtn.textContent = "Uploading photos...";
          console.log("[CRW] Starting image uploads for", stagedFiles.length, "file(s)...");
          try {
            const uploadResults = await Promise.all(stagedFiles.map(f => uploadImageToDrive(f)));
            driveImageUrls = uploadResults;
            console.log("[CRW] All uploads complete. Drive URLs:", driveImageUrls);
          } catch (err) {
            console.error("[CRW] Image upload error (review will still submit without photo):", err);
          }
        } else {
          console.log("[CRW] No images to upload.");
        }

        const pictureUrlsString = driveImageUrls.join(",");
        console.log("[CRW] picture_urls to save in sheet:", pictureUrlsString);

        const localBlobUrls = Array.from(preview.querySelectorAll("img")).map(img => img.src).join(",");

        submitBtn.textContent = "Submitting...";

        const reviewerEmail = this.container.querySelector(".crw-input-email").value;
        const localId = "local_" + Date.now();
        const newReview = {
          title: "",
          body: reviewText,
          rating: String(selectedRating),
          review_date: new Date().toISOString(),
          source: "widget",
          curated: "",
          reviewer_name: name,
          reviewer_email: email,
          product_id: "",
          product_handle: this.productHandle,
          reply: "",
          reply_date: "",
          picture_urls: driveImageUrls.join(","),
          ip_address: "",
          location: "",
          metaobject_handle: "",
          status: "pending",
          user_identifier: this.container.querySelector(".crw-input-email").value + "-" + Date.now(), // <-- ADD THIS LINE,
          _localId: "local-" + Date.now(), // Ensures compatibility with the local pending review arrays          
          _likes: 0,
        };

        // Save locally for pending display
        const pending = getPendingReviews();
        pending.push(newReview);
        localStorage.setItem("crw_pending", JSON.stringify(pending));

        // Step 2: Submit the review to the sheet with real Drive picture URLs.
        console.log("[CRW] Submitting review to sheet. picture_urls:", pictureUrlsString);
        try {
          const submitResp = await fetch(WIDGET_CONFIG.SUBMIT_URL, {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: JSON.stringify({
              action: "submitReview",
              review: {
                title: newReview.title,
                body: newReview.body,
                rating: newReview.rating,
                review_date: newReview.review_date,
                reviewer_name: newReview.reviewer_name,
                reviewer_email: newReview.reviewer_email,
                product_id: newReview.product_id,
                product_handle: newReview.product_handle,
                picture_urls: pictureUrlsString,
                metaobject_handle: newReview.metaobject_handle,
                status: "pending",
                user_identifier: this.userId,
                _localId: localId,
              },
            }),
          });
          const submitText = await submitResp.text();
          console.log("[CRW] submitReview raw response:", submitText);
          console.log("[CRW] submitReview parsed:", JSON.parse(submitText));
        } catch (e) {
          console.error("[CRW] submitReview fetch error:", e);
        }

        // Update display
        this.allReviews.unshift(newReview);
        this.applySort();
        this.renderReviews();
        this.renderStats();

        successMsg.classList.add("show");
        submitBtn.disabled = false;
        submitBtn.textContent = t.submit;

        // Reset form
        this.container.querySelector(".crw-input-name").value = "";
        this.container.querySelector(".crw-input-email").value = "";
        this.container.querySelector(".crw-input-review").value = "";
        selectedRating = 0;
        starSpans.forEach(s => s.classList.remove("lit"));
        preview.innerHTML = "";
        stagedFiles = [];

        setTimeout(() => {
          formWrap.classList.remove("open");
          successMsg.classList.remove("show");
        }, 4000);
      });
    }
  }

  /* ─── AUTO-INIT ─── */
  function init() {
    document.querySelectorAll("[data-crw-reviews]").forEach(el => {
      const handle = el.dataset.crwReviews || "";
      new ReviewsWidget(el, handle);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.ReviewsWidget = ReviewsWidget;
})();